import { GENDER_SELECT_OPTIONS } from '../misc/Constants'


const ENROLLMENT_STATUS_STATES = ['active', 'future', 'waitlist', 'inactive']
const SORT_STATES = ['asc', 'desc']


export const STUDENTS_COLUMNS = [
  {
    label: 'Years in Community',
    field: 'first_activity',
    exportKey: 'years_in_community',
    gridWidth: 'minmax(220px, 1fr)',
    skeletonType: 'longValue',
  },
  {
    label: 'Enrollment Status',
    field: 'enrollment_status',
    exportKey: 'enrollment_status',
    gridWidth: 'minmax(200px, 1fr)',
    skeletonType: 'longValue',
  },
  {
    label: 'Total Enrollments',
    field: 'total_enrollments',
    exportKey: 'total_enrollments',
    gridWidth: 'minmax(160px, 1fr)',
    skeletonType: 'value',
  },
  {
    label: 'Total Revenue',
    field: 'total_revenue',
    exportKey: 'total_revenue',
    gridWidth: 'minmax(160px, 1fr)',
    skeletonType: 'longValue',
  },
  {
    label: 'Strokes Lost',
    field: 'strokes_lost',
    exportKey: 'strokes_lost',
    gridWidth: 'minmax(160px, 1fr)',
    skeletonType: 'value',
  },
  {
    label: '9HE Rounds',
    field: 'nine_hole_rounds',
    exportKey: 'nine_hole_rounds',
    gridWidth: 'minmax(160px, 1fr)',
    skeletonType: 'value',
  },
  {
    label: 'Casual Rounds',
    field: 'casual_rounds',
    exportKey: 'casual_rounds',
    gridWidth: 'minmax(160px, 1fr)',
    skeletonType: 'value',
  },
  {
    label: 'Practice Sessions',
    field: 'practice_sessions',
    exportKey: 'practice_sessions',
    gridWidth: 'minmax(160px, 1fr)',
    skeletonType: 'value',
  },
  {
    label: 'Time Practiced',
    field: 'time_practiced',
    exportKey: 'time_practiced',
    gridWidth: 'minmax(160px, 1fr)',
    skeletonType: 'longValue',
  },
  {
    label: 'Age',
    field: 'age',
    exportKey: 'age',
    gridWidth: 'minmax(100px, 1fr)',
    skeletonType: 'value',
  },
  {
    label: 'Gender',
    field: 'gender',
    exportKey: 'gender',
    gridWidth: 'minmax(100px, 1fr)',
    skeletonType: 'longValue',
  },
  {
    label: 'Level',
    field: 'level',
    exportKey: 'level',
    gridWidth: 'minmax(100px, 1fr)',
    skeletonType: 'value',
  },
  {
    label: 'Latest Program Enrolled',
    field: 'latest_program_enrolled',
    exportKey: 'latest_program_enrolled',
    gridWidth: 'minmax(200px, 1fr)',
    skeletonType: 'longValue',
  },
]

export const DEFAULT_SORT_OPTION = { sortField: STUDENTS_COLUMNS.at(0).field, sortValue: SORT_STATES.at(0) }

export const getSortStates = (sortField) => {
  switch (sortField) {
    case 'enrollment_status':
      return ENROLLMENT_STATUS_STATES
    case 'gender':
      return GENDER_SELECT_OPTIONS.map(gender => gender.value)
    default:
      return SORT_STATES
  }
}
